export default __webpack_public_path__ + "static/media/Ruth_Zubairu_AHV_In_Moms_We_Trust.58272fce.jpg";